module.exports = __webpack_public_path__ + "static/media/GROKCAT-USDT.a1cb4659.png";